import { z } from "zod";

import { getNormalEnum } from "./pseudoEnums.js";

const PROJECT_TEMPLATES_FOR_UI = [
  z.literal("DATA_APP"),
  z.literal("AD_HOC"),
  z.literal("CHAINED_SQL"),
] as const;

/** Project templates that are surfaced in the template panel as ones for a user to choose */
// eslint-disable-next-line tree-shaking/no-side-effects-in-initialization -- array spread is fine
export const ProjectTemplateForUILiteral = z.union(PROJECT_TEMPLATES_FOR_UI);
export const ProjectTemplateForUI = getNormalEnum(ProjectTemplateForUILiteral);
export type ProjectTemplateForUI = z.infer<typeof ProjectTemplateForUILiteral>;

// Project templates that only work with the new demo connection
const PROJECT_TEMPLATES_FOR_072025_DC = [
  z.literal("SQL_AND_PYTHON_TOUR_072025"),
  z.literal("SQL_ONLY_TOUR_072025"),
  z.literal("NO_CODE_TOUR_072025"),
  z.literal("B2B_REVENUE_DASHBOARD"),
  z.literal("OPPORTUNITY_REGRESSION_ANALYSIS"),
] as const;

export const ProjectTemplateFor072025DCLiteral = z.union(
  PROJECT_TEMPLATES_FOR_072025_DC,
);
export const ProjectTemplateFor072025DC = getNormalEnum(
  ProjectTemplateFor072025DCLiteral,
);
export type ProjectTemplateFor072025DC = z.infer<
  typeof ProjectTemplateFor072025DCLiteral
>;

/** All possible project templates, including ones that are only used behind-the-scenes */
export const ProjectTemplateLiteral = z.union([
  // eslint-disable-next-line tree-shaking/no-side-effects-in-initialization -- array spread is fine
  ...PROJECT_TEMPLATES_FOR_UI,
  ...PROJECT_TEMPLATES_FOR_072025_DC,
  z.literal("SQL_AND_PYTHON_TOUR"),
  z.literal("SQL_ONLY_TOUR"),
  z.literal("NO_CODE_TOUR"),
]);
export const ProjectTemplate = getNormalEnum(ProjectTemplateLiteral);
export type ProjectTemplate = z.infer<typeof ProjectTemplateLiteral>;
